import classNames from 'classnames';
import * as React from 'react';
import styles from './YouTube.module.css';

export interface YouTubeProps {
    videoId: string;
    title: string;
    className?: string;
}

export class YouTube extends React.PureComponent<YouTubeProps> {
    render() {
        const { videoId, title, className } = this.props;

        return (
            <div className={classNames(styles.YouTube, className)}>
                <iframe
                    loading="lazy"
                    title={title}
                    src={`https://www.youtube.com/embed/${videoId}`}
                    width="640"
                    height="480"
                    allow="autoplay; fullscreen"
                    data-ready="true"
                />
            </div>
        );
    }
}
